
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isNative, isDesktop } from '../utils/globalConfig';
import { Title, Body } from '@vds/typography';
import { Icon } from '@vds/icons';
import { Line } from '@vds/lines';
import { useLazyGetBillSummaryByNameQuery } from '../../features/devicesAndPlans/billSummaryFetch';
import ComponentLoader from './ComponentLoader';
import { TextLink } from '@vds/buttons';
import { nativeOpenInWebview } from '../utils/native';

const Space = styled.div`
padding-top: ${props => props.pt || 8}px;
`
const StyledBillDiv = styled.div`
display: flex;
max-width: 328px;
justify-content: space-between;
`
const StyledBillAmtDiv = styled.div`
display: flex;
max-width: 430px;
justify-content: space-between;
`
const StyledTitle = styled(Title)`
margin-left: 20%
`
const StyledBody = styled.div`
width: ${isDesktop ? '750px' : ''}
`

const Billchange = () => {

    const [billChangesData, setBillChangesData] = useState();

    const [triggerBillApi, { data, error, isLoading, isSuccess }] = useLazyGetBillSummaryByNameQuery();

    useEffect(() => {
        triggerBillApi();
    }, [])

    useEffect(() => {
        setBillChangesData(data?.body?.data?.nextBillSummary);
    }, [data])

    const navigateToBillPage = () => {
        const billUrl = billChangesData?.billDetailsUrl || '/digital/nsa/secure/ui/bill/overview/';
        const billUrlNative = window.location.origin + billUrl
        if (isNative) {
            nativeOpenInWebview(billUrlNative)
        } else {
            window.open(billUrl)
        }
    }

    return (
        <>
            {(isSuccess && billChangesData) ?
                <>
                    <Space />
                    <Title size="XLarge">{billChangesData?.heading}</Title>
                    <Space pt={24} />
                    <StyledBillDiv>
                        <Title size="small">{billChangesData?.currentBillLabel}</Title>
                        <StyledTitle size="small">{billChangesData?.newBillLabel}</StyledTitle>
                    </StyledBillDiv>
                    <StyledBillAmtDiv>
                        <Title size="XLarge" bold>{billChangesData?.currentBillValue}</Title>
                        <Icon
                            name="right-arrow"
                            size="large"
                            color="#000000"
                        />
                        <StyledTitle size="XLarge" bold>{billChangesData?.newBillValue}</StyledTitle>
                    </StyledBillAmtDiv>
                    <Space pt={24} />

                    <StyledBody >
                        <Body size="large">
                            <span>{billChangesData?.text}</span>
                            <TextLink data-testid="billLinkId" onClick={() => navigateToBillPage()}>{billChangesData?.billDetailsLabel || 'Bill details'}</TextLink>
                        </Body>
                    </StyledBody>
                    <Space pt={24} />
                    <Line type="secondary" />
                    <Space pt={24} />
                    <Body color="#6F7171" size="small">{billChangesData?.disclaimerText1}</Body>
                    <Space pt={24} />
                    <Body color="#6F7171" size="small">{billChangesData?.disclaimerText2}</Body>
                    <Space pt={48} />

                </> : (error && <></> )
            }
            {isLoading && <ComponentLoader />}
        </>

    )
}

export default Billchange;